<template>
	<div>
		<Loading v-if="!status" />
		<AdminAccountForm
			v-else-if="status === 200"
			edit
			ref="form"
			:loading="submitting"
			@submit="onSubmit"
			@cancel="onCancel"
			@hook:mounted="populate"
		/>
	</div>
</template>

<script>
import api from '@/mixins/api'
import toast from '@/mixins/toast'
import Loading from '@/components/shared/Loading'
import AdminAccountForm from '@/components/admin/AdminAccountForm'

export default {
	name: 'EditAdminAccount',
	data() {
		return {
			status: 0,
			submitting: false,
			existing: null
		}
	},
	computed: {
		id() {
			return this.$route.params.id
		}
	},
	methods: {
		populate() {
			this.existing.then(this.$refs.form.populate)
		},
		async onSubmit({ id, username, email, role }) {
			const body = JSON.stringify({ username, email, role })

			// Submit updated account
			this.submitting = true
			try {
				// Create the account
				await this.put(`/users/${id}`, { body })
				this.toast(`Successfully *updated* the account for *${username}*.`)

				// Navigate to manage accounts page
				this.$router.push({ name: 'Admin Accounts' })
			} catch (err) {
				switch (err.name) {
					case 'APIValidationError':
						this.toastWarn('Please check the account details and try again.')
						break
					default:
						this.toastErr(
							'Failed to update this account. Please try again later.'
						)
						break
				}
			}
			this.submitting = false
		},
		onCancel() {
			this.$router.go(-1)
		}
	},
	async created() {
		try {
			// Set existing data as promise for later consumption
			const res = await this.get(`/users/${this.id}`)
			this.status = res.status
			this.existing = res.json().then(user => {
				return { ...user, role: user.role.id }
			})
		} catch (err) {
			this.status = err.status || 500
		}
	},
	mixins: [api, toast],
	components: {
		Loading,
		AdminAccountForm
	}
}
</script>
